// src/pages/ForgotPasswordPage.js
import React, { useState } from "react";
import axios from "axios";
import API_URL from "../api/baseURL";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await axios.post(`${API_URL}/auth/forgot-password`, { email });
      setSubmitted(true);
    } catch (err) {
      setError("Could not send reset email. Please try again.");
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white dark:bg-gray-900 shadow rounded">
      <h2 className="text-2xl font-bold mb-4 text-gray-800 dark:text-gray-200">Forgot Password</h2>
      {submitted ? (
        <div className="text-green-600">
          If the email exists, you'll receive a reset link shortly.
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            placeholder="Your email address"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
            className="w-full border p-2 rounded"
          />
          <button type="submit" className="w-full bg-blue-600 text-white py-2 rounded">
            Send Reset Link
          </button>
        </form>
      )}
      {error && <div className="text-red-500 mt-3">{error}</div>}
    </div>
  );
}


